import React, { Component } from "react";
import PageAwardsAward from './PageAwardsAward';
import { Link } from 'react-router-dom';

export default class PageFeatured extends Component {

	constructor(props) {
		super(props)
		this.onTopIntersection = this.onTopIntersection.bind(this);
		this.onBottomIntersection = this.onBottomIntersection.bind(this);
		this.onTextIntersection = this.onTextIntersection.bind(this);
		this.state = {
			topInView: false,
			bottomInView: false,
			textInView: false,
		}
	}

	componentDidMount() {
		if (this.$topBox) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let topObserver = new IntersectionObserver(this.onTopIntersection, options);
			topObserver.observe(this.$topBox);
		}
		if (this.$bottomBox) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let bottomObserver = new IntersectionObserver(this.onBottomIntersection, options);
			bottomObserver.observe(this.$bottomBox);
		}
		if (this.$textBox) {
			let loadObserver;
			let options = {
				root: null,
				rootMargin: "-20% 0px -20% 0px",
				threshold: 0
			};
			let textObserver = new IntersectionObserver(this.onTextIntersection, options);
			textObserver.observe(this.$textBox);
		}
	}

	onTopIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.topInView === false) {
				this.setState({ topInView: true });
			}						
		});
	} 
	
	onBottomIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.bottomInView === false) {
				this.setState({ bottomInView: true });
			}						
		});
	} 
	
	onTextIntersection(entries, observer) {
	    entries.map((entry) => {
			if (entry.intersectionRatio > 0 && this.state.textInView === false) {
				this.setState({ textInView: true });
			}						
		});
	} 
		  	
	render () {
		
		let block = this.props.block;
										
	    return (
		    
			<div id={block.id} className={'c-page__block ' + (this.state.inView ? "state-in-view" : "")}>
		     
				<div className="c-awards">
				
					
			    
			    	<div className="c-awards__inner">
			    		
			    		{block.text &&
				    		<div className={'c-awards__text ' + (this.state.textInView ? "state-in-view" : "")} ref={(textBox) => { this.$textBox = textBox; }}>
				    			<div className="c-awards__text__inner scope-large-text" dangerouslySetInnerHTML={ {__html:block.text}}></div>
				    		</div>
			    		}
			    		
			    		{block.heading &&
				    		<div className={'c-awards__header ' + (this.state.topInView ? "state-in-view" : "")} ref={(topBox) => { this.$topBox = topBox; }}>
				    			<h2 className="c-awards__heading" dangerouslySetInnerHTML={ {__html: block.heading}}></h2>
				    		</div>
			    		}
			    				    			
		    			{block.awards.map((award,i) =>
							{
								return (
									<PageAwardsAward award={award} key={i}></PageAwardsAward>
								)
							}
						)}
						
						{block.button_text && block.button_url &&
							<div className={'c-awards__buttons ' + (this.state.bottomInView ? "state-in-view" : "")} ref={(bottomBox) => { this.$bottomBox = bottomBox; }}>
				    			<Link to={{ pathname: block.button_url }} className="c-awards__buttons__button" dangerouslySetInnerHTML={ {__html: block.button_text}}></Link>
				    		</div>
						}
						    				    					    
					</div>
					
				</div>
				
		    </div>
		)
	}
}
